import { IProfileResponse } from "@finbackoffice/clientbff-client";
import { AccountConfigType } from "@finbackoffice/fe-core";
import { useMemo } from "react";
import { useRuntimeConfig } from "./useRuntimeConfig";

export const useProfileDetailsConfig = (fields?: string[]) => {
    const SITE_CONFIG = useRuntimeConfig("SITE_CONFIG");
    const accountDetailsConfig = SITE_CONFIG._accountFields;

    const accountDetailsConfigCollections = useMemo(
        () => accountDetailsConfig.filter((config) => config.enable),
        [accountDetailsConfig],
    );

    const accountDetailsConfigObject = useMemo(() => {
        const result: Partial<Record<keyof IProfileResponse, AccountConfigType>> = {};

        accountDetailsConfigCollections?.forEach((collection) => {
            if (collection.config) {
                collection.config?.forEach((config) => {
                    if (config.enable && (fields ? fields.includes(config.name) : true)) {
                        result[config.name as keyof IProfileResponse] = config;
                    }
                });
            } else {
                if (collection.enable && (fields ? fields.includes(collection.name) : true)) {
                    result[collection.name as keyof IProfileResponse] = collection;
                }
            }
        });

        return result;
    }, [accountDetailsConfigCollections, fields]);

    return { accountDetailsConfigObject, accountDetailsConfigCollections };
};
